module.exports = __webpack_public_path__ + "static/media/1f4aa.86dd7f49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4aa.svg
// module id = 629
// module chunks = 1